exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-37aa32d0] {\n  background-color: #f44336;\n  color: white !important;\n  font-weight: bold;\n}\n", ""]);

// exports
